import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import NewsService from '../../services/News';
import {
  NewsItemsStyled,
  NewsItemsHeaderEnd,
  ErrorWrapper,
  LoadingWrapper,
} from './styles/NewsStyled';
import Container from '../General/Container';
import ServiceError from '../General/ServiceError/ServiceError';
import NewsItems from './NewsItems/NewsItems';
import MotionLoading from '../UI/MotionLoading/motionLoading';
import Loading from '../General/Loading';
import { GoogleTagManager } from '../../helpers';

const News = ({ lastNewsId, setNewsNotification }) => {
  const [data, setData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [dataError, setDataError] = useState(false);

  const loadData = () => {
    setDataLoading(true);
    NewsService.getNews()
      .then(res => {
        setData(res[0].news);
        setDataLoading(false);
        setDataError(false);
      })
      .catch(() => {
        setDataLoading(false);
        setDataError(true);
      });
  };
  useEffect(() => {
    loadData();
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('lastNews', lastNewsId);
      setNewsNotification(false);
    }

    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/news',
      pagename: 'News',
    });
  }, []);

  return (
    <NewsItemsStyled>
      <NewsItemsHeaderEnd />
      {dataLoading ? (
        <LoadingWrapper>
          <Container>
            <Loading />
          </Container>
        </LoadingWrapper>
      ) : (
        <MotionLoading loading={dataLoading}>
          {!dataError ? <NewsItems data={data} /> : null}
        </MotionLoading>
      )}
      {dataError && !dataLoading ? (
        <ErrorWrapper>
          <Container background="#FFF" padding="56px 20px 37px 20px">
            <ServiceError click={loadData} />
          </Container>
        </ErrorWrapper>
      ) : null}
    </NewsItemsStyled>
  );
};

News.propTypes = {
  lastNewsId: PropTypes.string.isRequired,
  setNewsNotification: PropTypes.func.isRequired,
};

export default News;
